import * as actions from './actions';
import { NotificationsState, NotificationsActionPayload } from './types';

const initialState: NotificationsState = {
  stream: {
    activity: 0,
    notifications: 0,
  },
  // other notification types...
};

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state = initialState, { type }: NotificationsActionPayload) => {
  switch (type) {
    case actions.INCREMENT_STREAM_ACTIVITIES:
      return {
        stream: {
          ...state.stream,
          activity: state.stream.activity + 1,
        },
      };
    case actions.DECREMENT_STREAM_ACTIVITIES:
      return {
        stream: {
          ...state.stream,
          activity: state.stream.activity - 1,
        },
      };
    case actions.RESET_STREAM_ACTIVITIES:
      return {
        stream: {
          ...state.stream,
          activity: 0,
        },
      };
    case actions.INCREMENT_STREAM_NOTIFICATIONS:
      return {
        stream: {
          ...state.stream,
          notifications: state.stream.notifications + 1,
        },
      };
    case actions.DECREMENT_STREAM_NOTIFICATIONS:
      return {
        stream: {
          ...state.stream,
          notifications: state.stream.notifications - 1,
        },
      };
    case actions.RESET_STREAM_NOTIFICATIONS:
      return {
        stream: {
          ...state.stream,
          notifications: 0,
        },
      };
    case actions.RESET_STREAM_ALERTS:
      return initialState;
    default:
      return state;
  }
};
